import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/footer';
import AppRoutes from './routes/AppRoutes';
import ScrollToTopButton from './components/ScrollToTopButton';
import ScrollTop from './components/ScrollTop';

const App = () => {
  return (
    <Router>
      <ScrollTop />
      <ScrollToTopButton />
      <Navbar />
      <AppRoutes />
      <Footer />
    </Router>
  );
};

export default App;
